import { useQuery } from "@tanstack/react-query";

import { GetOrgChartResponseJSON } from "@performyard/service-contracts";

import { getOrgChartQuery } from "../../queries";
import { PYUseQueryOptions } from "../StandardQueryArguments";

export const useOrgChart = (options?: PYUseQueryOptions<GetOrgChartResponseJSON>) => {
	return useQuery<GetOrgChartResponseJSON>(getOrgChartQuery(options));
};
